import { setLoaderStart, setLoaderComplete } from '../../loader/loader';
import histroy from '../../../history';
import { showToaster } from '../../../helpers/toastrMessgaes/showToaster';
import { addLocationMutation } from '../../../lib/graphql';

export const addLocation = (LocationName, coordinates, description) => {

  return async (dispatch, getState, { client }) => {

    try {
      dispatch(setLoaderStart('AddLocation'));

      if (!coordinates || coordinates == '') {
        showToaster({ messageId: 'selectLoc', toasterType: 'error' });
        return dispatch(setLoaderComplete('AddLocation'));
      }

      const { data } = await client.mutate({
        mutation: addLocationMutation,
        variables: {
          LocationName,
          coordinates,
          description
        },
      });

      if (data?.addLocation?.status === 200) {
        showToaster({ messageId: 'addLoc', toasterType: 'success' });
        histroy.push('/siteadmin/location');
      } else {
        showToaster({ messageId: 'errorMessage', requestContent: { content: data?.addLocation?.errorMessage }, toasterType: 'error' });
      }
      dispatch(setLoaderComplete('AddLocation'));
    } catch (error) {
      dispatch(setLoaderComplete('AddLocation'));
      showToaster({ messageId: 'catchMessage', requestContent: { content: err }, toasterType: 'error' });
    }

  }
}